import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    infoIcon: {
        top: 2,
        position: 'relative',
    },
    errorMessage: {
        marginLeft: 10,
        fontSize: 14,
        lineHeight: 1.2,
        color: theme.palette.error.main,
    },
    visibilityButton: {
        cursor: 'pointer',
    },
}));
